export default __webpack_public_path__ + "static/ThinkstockPhotos-89118153_article-f04e56ed2e2e9ad43cff1c829cc63f5a.jpg";